import {get } from '../axios'
const wx = {
  // 获取患者
  queryAccessToken: code => get(`/web/weixin/queryAccessToken/${code}`),
  // 20241024 测试微信跳转
  queryAccessTokenWithState: (code, researchCode, centerCode) => get(`/web/weixin/queryAccessTokenWithState/${code}/${researchCode}/${centerCode}`)
}
export default wx